import React from 'react';

import Icon from '../Icon';

import { ButtonMaterial, Container } from './styles';
import { FiBook } from 'react-icons/fi';

interface IMovieCardOnlyCoverProps {
  cover: string;
  height?: string;
  onClick(): void;
  material_url?: string;
}

const MovieCardOnlyCover: React.FC<IMovieCardOnlyCoverProps> = ({  cover, height, onClick, material_url }) => {

  return (
      <Container cover={cover} height={height}>
        <main onClick={onClick}>
          <div>
            <Icon icon="icon-icon-play" size="50px" margin="0 0 0 5px" />
          </div>
        </main>
        {material_url && (
          <ButtonMaterial href={material_url} target="_blank" rel="noopener noreferrer">
            <span>MATERIAL COMPLEMENTAR</span>
          </ButtonMaterial>
        )}
      </Container>
  );
}

export default MovieCardOnlyCover;
